import React, { useState } from "react";
import { IoChevronBack } from "react-icons/io5";
import logo from "../../images/ic-password.png";
import logo1 from "../../images/LogoDashboard.png";

import AuthButton from "../../Components/AuthButton/AuthButton";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import Input from "../../Components/Input/Input";
import { useDispatch } from "react-redux";
import { postForgetPass, postResetPass } from "../../Actions/actions";
import Loader from "../../Components/Loader/Loader";
import { useSelector } from "react-redux";

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const { loader } = useSelector((state) => state.userReducer);

  const [password, setPassword] = useState("");
  const [confrimPassword, setConfrimPassword] = useState("");
  const [errors, setErrors] = useState({ email: "" });
  const dispatch = useDispatch();

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleConformPasswordChange = (e) => {
    setConfrimPassword(e.target.value);
  };

  const validateForm = () => {
    let valid = true;
    let errors = {};

    if (!password) {
      errors.password = "Please enter a password";
      valid = false;
    }
    if (!confrimPassword) {
      errors.confrimPassword = "Please enter a confirm password";
      valid = false;
    }
    if (confrimPassword != password) {
      errors.confrimPassword = "Do not match confirm password";
      valid = false;
    }
    setErrors(errors);
    return valid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      dispatch(
        postResetPass(password, token, () => {
          navigate("/");
        })
      );
    }
  };

  return (
    <div className="font-public min-h-screen flex flex-col items-center justify-center bg-white">
    <div className="absolute top-10 left-10">
      <img src={logo1} alt="Repotal Logo" className="w-[200px] h-auto" />
    </div>

    <div className="mb-6">
      <img src={logo} alt="Repotal Logo" className="w-20 h-auto" />
    </div>

    <h2 className="text-2xl font-semibold text-center text-[#361D32] mb-4">
      Reset your password?
    </h2>
    <p className="text-sm text-center text-gray-600 mb-6 w-[82.5%]  md:w-[50%]   lg:w-[38%]  sm:w-[60%] xl:w-[27.5%]">
      Please enter a new password for your account. Make sure it’s strong and
      easy for you to remember.
    </p>
    <div className="w-[380px] -mb-6 px-4">
      <Input
        password={true}
        type={"password"}
        label={"New Password"}
        value={password}
        onChange={handlePasswordChange}
        error={errors.password}
      />
    </div>
    <div className="w-[380px] px-4">
      <Input
        password={true}
        type={"Confirm password"}
        label={"Confirm password"}
        value={confrimPassword}
        onChange={handleConformPasswordChange}
        error={errors.confrimPassword}
      />
    </div>
    {loader ? (
      <div className="p-4">
        <Loader />
      </div>
    ) : (
      <div className="px-4 w-full">
      <div className="flex justify-center">
        <button
          type="submit"
          onClick={handleSubmit}
          className="w-full max-w-sm text-white py-2 text-sm bg-[#361D32] rounded-md font-semibold mb-4"
        >
          Save Changes
        </button>
      </div>
    </div>
    
    )}

    <div
      onClick={() => {
        navigate("/");
      }}
      className="flex items-center text-purple-900 font-medium cursor-pointer"
    >
      <IoChevronBack className="mr-1 text-black" />
      <p className="text-[#361D32]">Return to sign in</p>
    </div>
  </div>
  );
}
